import { render, staticRenderFns } from "./AutoInfracaoSigamSp.vue?vue&type=template&id=5d67c737&lang=pug"
import script from "./AutoInfracaoSigamSp.vue?vue&type=script&lang=js"
export * from "./AutoInfracaoSigamSp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports